import { graphql } from 'react-apollo'
import { ApplicationError, NotFoundError } from '../../helpers/errors'
import getPaymentMethodsFromRetailer from '../../helpers/get-payment-methods-from-retailer'
import getLogoFromRetailer from './../../helpers/get-logo-from-retailer'
import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({ match }) => ({
  variables: {
    slugQuery: `fields.slug=${match.params.centre}`,
  },
  errorPolicy: 'ignore',
})

export const mapDataToProps = ({ data: { loading, error, centres } }) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  } else if (!centres[0]) {
    return {
      error: new NotFoundError(error),
    }
  }

  const centre = centres[0]

  const stores = centre.stores.entries
    .map(store => ({
      ...store,
      paymentMethods: getPaymentMethodsFromRetailer(store),
      link: `/${centre.slug}/store/${store.sys.id}/${store.slug}`,
      logo: getLogoFromRetailer(store.retailer),
    }))
    .sort((storeA, storeB) => storeA.title.localeCompare(storeB.title))
  return {
    stores,
    centreName: centre.title,
    centreSlug: centre.slug,
  }
}

const withStores = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withStores
